module.exports = __webpack_public_path__ + "static/img/14000752.3ce24478.png";